import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './text-link.scss.js';

class TextLink extends s {
    render() {
        return $ `<a class="link" type="button" href="${this.url}"><span class="link-text">${this.title}</span></a>`;
    }
}
TextLink.styles = css_248z;
__decorate([
    e({ type: String })
], TextLink.prototype, "title", void 0);
__decorate([
    e({ type: String })
], TextLink.prototype, "url", void 0);
customElements.define('text-link', TextLink);

export { TextLink };
